
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holidays/hotels/[estabId]",
      function () {
        return require("private-next-pages/holidays/hotels/[estabId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holidays/hotels/[estabId]"])
      });
    }
  